import { Trans, useTranslation } from "react-i18next";

export default function UpsellPreview({ formValues }) {
  const { t } = useTranslation("upsells");

  const formatName = (name: string) => {
    if (!name) return "";

    return name.replace(/\s*-\s*(US\$?|€|R\$)\s*[\d,.]+$/, "");
  };

  const mockProductData = {
    name: formatName(formValues.name),
    price: formValues.price,
    up_sell_display_text: formValues.up_sell_display_text || t('form_placeholders.default_accept'),
    up_sell_button_color: formValues.up_sell_button_color || '#a9d342',
    up_sell_display_text_color: formValues.up_sell_display_text_color || '#ffffff',
    down_sell_display_text: formValues.down_sell_display_text || t('form_placeholders.default_decline'),
    down_sell_button_color: formValues.down_sell_button_color || '#F87171',
    down_sell_display_text_color: formValues.down_sell_display_text_color || '#ffffff'
  };

  return (
    <div className="flex flex-col w-full gap-4">
      <h2 className="text-2xl font-bold text-center m-0">
        {mockProductData.name}
      </h2>

      <div className="text-xl text-center text-zinc-400 mb-2 leading-none">
        {mockProductData.price}
      </div>

      <button
        className="w-full py-3 px-6 rounded-lg font-semibold text-lg border-none transition-all duration-300 ease-in-out shadow-md hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0"
        style={{
          backgroundColor: mockProductData.up_sell_button_color,
          color: mockProductData.up_sell_display_text_color
        }}
      >
        {mockProductData.up_sell_display_text}
      </button>

      <button
        className="w-full py-3 px-6 rounded-lg font-semibold text-lg border-none transition-all duration-300 ease-in-out shadow-md hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0"
        style={{
          backgroundColor: mockProductData.down_sell_button_color,
          color: mockProductData.down_sell_display_text_color
        }}
      >
        {mockProductData.down_sell_display_text}
      </button>

      <div className="text-sm text-gray-400 text-center px-4 leading-relaxed">
         <Trans
          i18nKey="termsNotice"
          components={{
            1: (
              <a
                href="https://mundpay.com/termos-de-uso"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary no-underline transition-colors duration-200 hover:underline"
              />
            )
          }}
        >
          {t('termsNotice')}
        </Trans>
      </div>
    </div>
  );
}
